import axios from 'axios'
import eventBus from '@utils/eventBus';
import Utils from '@utils/utils';
import { message } from 'antd';

const preproductionBaseUrl  = `http://canary.ps.arcsoftbiz.com` // 灰度版本 staging
const productionBaseUrl  = `https://psai.cn` // 上线版本 production
const testBaseUrl = `http://172.17.13.140:8083` // 测试版本 test

// const devBaseUrl = `https://applepay.arcsoft.com.cn` // 阿里云测试版 development
const devBaseUrl = `http://172.17.13.140:8083` // 阿里云测试版 development
// const devBaseUrl = `http://172.17.13.187:8084` // Dr.wang 版本 development
// const devBaseUrl = `http://172.17.122.239:8084` // qingyu本地 development
// const devBaseUrl = `http://172.21.101.70:8084` // peidong本地 development shanghai
// const devBaseUrl = `http://172.17.227.41:8084` // peidong本地 development hangzhou

const url  = process.env.NODE_ENV == 'development' ? devBaseUrl :
            process.env.NODE_ENV == 'test' ? testBaseUrl:
            process.env.NODE_ENV == 'staging' ? preproductionBaseUrl:
            productionBaseUrl

const uploadImage = url +  "/aishops/common/uploadImage";
const uploadImageWithToken = url + "/aishops/common/uploadImageWithToken"
const userSendCode = url + '/ps/web/merchant/user/sendCode';
const userLogin = url + '/ps/web/merchant/user/login';
const emailRegister = url + '/ps/web/merchant/user/emailRegister';
const powerPackages = url + '/ps/web/order/powerPackages';
const userInfo = url + '/ps/web/merchant/user/userInfo';
const payForOrder = url + '/ps/web/order/payForOrder';
const checkVerifyCodeUrl = url + '/ps/web/merchant/user/checkVerifyCode'
const changeMobileUrl = url + '/ps/web/merchant/user/changeMobile'
const setPasswordUrl = url + '/ps/web/merchant/user/setPassword'
const logout = url + '/ps/web/merchant/user/logout';
const getVersionUrl = url + '/ps/web/version'

const forgetPassword = url + '/ps/web/merchant/user/forgetPassword'
const scoreImage = url + '/ps/web/project/scoreImage'

const setCmRead = url + '/ps/web/merchant/user/setCmRead'

const usercaptcha = url + '/ps/web/merchant/user/captcha'

const listOrder = url + '/ps/web/merchant/listOrder' //大客户交付
const getOrderDetails = url + '/ps/web/merchant/getOrderDetails' //大客户需求页详细数据
const confirmOrder = url + '/ps/web/merchant/confirmOrder' //大客户-确认拒绝订单
const listWithSku = url + '/ps/web/merchant/listWithSku' //大客户交付页订单列表
const listArtifactsBySku = url + '/ps/web/merchant/listArtifactsBySku' //根据sku获取成片图
const dashboardInfo = url + '/ps/web/merchant/dashboardInfo' //大客户需求页统计数据
const merchantdownload = url + '/ps/web/merchant/download'
const merchantdownloadBatch = url + '/ps/web/merchant/downloadBatch'
const merchantrefine = url + '/ps/web/merchant/refine'
const merchantpowerBalance = url + '/ps/web/merchant/powerBalance'
const merchantgetUsageBillList = url + '/ps/web/merchant/getUsageBillList'
const paymentOrderStatus = url + '/ps/web/merchant/paymentOrderStatus'
const merchantgetOrderList = url + '/ps/web/merchant/getOrderList'
const merchantpayForOrder = url + '/ps/web/merchant/payForOrder'
const listDeliverySku = url + '/ps/web/merchant/listDeliverySku'
const listPhotoBySku = url + '/ps/web/merchant/listPhotoBySku'
const markPhoto = url + '/ps/web/merchant/markPhoto'
const submitPhoto = url + '/ps/web/merchant/confirmPhoto'


// 添加响应拦截器
axios.interceptors.response.use(function (response) {
    // console.log('axios.interceptors.response', response)
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    if (response.data?.code == -4001 || response.data?.code == -5023) {
        response.data.message = "" // 将message置空，避免多次弹出未授权消息框
        localStorage.removeItem('token')
        sessionStorage.removeItem('taskCache_model')
        sessionStorage.removeItem('taskCache_dressform')
        sessionStorage.removeItem('taskCache_clothes')
        sessionStorage.removeItem('taskCache_commodity')
        sessionStorage.removeItem('taskCache_tryonVideo')
        sessionStorage.removeItem('taskCache_commodityVideo')
        eventBus.emit('tokenExpired', {pathname: location.pathname})
        // message.error('token过期,请重新登录')
        // throw new Error('登录失效')
    }
    return response
}, function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    console.log('axios.interceptors.response error')
    console.dir(error)
    return Promise.reject(error);
})

function getFun(url) {
    return function (params) {
        return new Promise(function (resolve, reject) {
            axios.get(url + '?ts=' + new Date().getTime(),{params, headers: {
                'Ps-Auth-Token': localStorage.getItem('token')
            }}).then(function (res) {
                if (res.status >= 200 && res.status < 300) {
                    resolve(res.data)
                }
            }).catch((error) => {
                    reject(error)
            })
        })
    }
}

function postFun(URL, params, signal) {
    return function (data) {
        return new Promise(function (resolve, reject) {
            axios.post(
                URL+ '?ts=' + new Date().getTime(),
                data,
                {
                    params,
                    headers: { 'Ps-Auth-Token': localStorage.getItem('token') },
                    signal
                }
            ).then(function (res) {
                if (res.status >= 200 && res.status < 300) {
                    resolve(res.data)
                }
            }).catch((error) => {
                reject(error)
            })
        })
    }
}

function putFun(URL, params) {
    return function (data) {
        return new Promise(function (resolve, reject) {
            axios.put(URL+ '?ts=' + new Date().getTime(),data,{params, headers: {
                'Ps-Auth-Token': localStorage.getItem('token')
            }}).then(function (res) {
                if (res.status >= 200 && res.status < 300) {
                    resolve(res.data)
                }
            }).catch((error) => {
                    reject(error)
            })
        })
    }
}

function deleteFun(URL) {
    return function (params) {
        return new Promise(function (resolve, reject) {
            axios.delete(URL+ '?ts=' + new Date().getTime(),{params, headers: {
                'Ps-Auth-Token': localStorage.getItem('token')
            }}).then(function (res) {
                if (res.status >= 200 && res.status < 300) {
                    resolve(res.data)
                }
            }).catch((error) => {
                    reject(error)
            })
        })
    }
}



export function commonApiInvoker (apiPromise, setLoading, rejectAccept) {
    return new Promise((resolve, reject) => {
        setLoading && setLoading(true)
        return apiPromise.then(res => {
            // console.log('res', res,)
            if (res.code != 200 && res.code != 0) throw new Error(res.message)
            resolve(res.data)
        }).catch(err => {
            console.error(err.message)
            message.warning(err.message)
            rejectAccept && reject(err)
        }).finally(() => {
            setLoading && setLoading(false)
        })
    })
}

export default  {
    commonApiInvoker: commonApiInvoker,
    uploadImage: (data, signal) => postFun(uploadImage, {}, signal)(data),
    uploadImageWithToken: postFun(uploadImageWithToken),
    userSendCode: data => postFun(userSendCode)({...data, platform: sessionStorage.getItem('platform')}),
    userLogin: data => postFun(userLogin)({...data, platform: sessionStorage.getItem('platform'), sourceId: sessionStorage.getItem('sourceId'), device: Utils.isMobileDevice()? 'web_mobile': 'web_pc', authCode: sessionStorage.getItem('code')}),
    emailRegister: data => postFun(emailRegister)({...data, platform: sessionStorage.getItem('platform'), sourceId: sessionStorage.getItem('sourceId'), device: Utils.isMobileDevice()? 'web_mobile': 'web_pc', authCode: sessionStorage.getItem('code')}),
    powerPackages: getFun(powerPackages),
    userInfo: getFun(userInfo),
    payForOrder: postFun(payForOrder),
    checkVerifyCode: data => postFun(checkVerifyCodeUrl)({...data, platform: sessionStorage.getItem('platform')}),
    changeMobile: data => postFun(changeMobileUrl)({...data, platform: sessionStorage.getItem('platform')}),
    setPassword: postFun(setPasswordUrl),
    logout: postFun(logout),
    getVersion: getFun(getVersionUrl),
    forgetPassword: data => postFun(forgetPassword)({...data, platform: sessionStorage.getItem('platform')}),
    scoreImage: postFun(scoreImage),
    setCmRead: postFun(setCmRead),
    usercaptcha: postFun(usercaptcha),
    paymentOrderStatus2: postFun(paymentOrderStatus),
    merchantgetOrderList: getFun(merchantgetOrderList),
    merchantpayForOrder: postFun(merchantpayForOrder),

    //大客户交付
    listOrder: getFun(listOrder), //需求页订单列表
    getOrderDetails: getFun(getOrderDetails), //订单详情
    confirmOrder:postFun(confirmOrder),//确认、拒绝订单
    listWithSku:getFun(listWithSku), //交付页订单列表
    listArtifactsBySku:getFun(listArtifactsBySku),//根据sku获取成片图
    dashboardInfo:getFun(dashboardInfo),//需求页统计数据
    merchantdownload: postFun(merchantdownload),
    merchantdownloadBatch: postFun(merchantdownloadBatch),
    merchantrefine: postFun(merchantrefine),
    merchantpowerBalance: getFun(merchantpowerBalance),
    merchantgetUsageBillList: getFun(merchantgetUsageBillList),
    listDeliverySku: getFun(listDeliverySku),
    listPhotoBySku: getFun(listPhotoBySku),
    markPhoto: postFun(markPhoto),
    submitPhoto: postFun(submitPhoto),

    merchantversionList: getFun(url + `/ps/web/merchant/versionList`), // 全部批次
    getMerchantCaptureDeliveryVersion: getFun(url + `/ps/web/merchant/getCaptureDeliveryVersion`), // 获取拍摄任务批次版本列表
    getCaptureDeliverySku: getFun(url + `/ps/web/merchant/getCaptureDeliverySku`), // 获取拍摄批次商品
    
    searchDeliverySku: getFun(url + `/ps/web/merchant/searchDeliverySku`), // 搜索订单批次
    listDeliveryByVersion: getFun(url + `/ps/web/merchant/listDeliveryByVersion`),
    merchantJudge: postFun(url + `/ps/web/merchant/judge`), // 选择通过/不通过
    merchantFeedback: postFun(url + `/ps/web/merchant/feedback`), // 提交反馈
    getDeliveryImage: getFun(url + `/ps/web/merchant/getDeliveryImage`),
    dashboardInfo: getFun(url + `/ps/web/merchant/dashboardInfo`),
    listPassImages: postFun(url + `/ps/web/merchant/listPassImages`),

    getPowerBalance: getFun(url + `/ps/web/merchant/powerBalance`), // 大客户获取剩余金额
    getDeliveryBillList: getFun(url + `/ps/web/merchant/getDeliveryBillList`), // 结算列表
    getBillDetail: getFun(url + `/ps/web/merchant/getBillDetail`), // 获取结算明细
    payForDeliveryBill: postFun(url + `/ps/web/merchant/payForDeliveryBill`), // 订单结算
    getDemandTags: getFun(url + `/ps/web/merchant/demand/tags`), // 标签列表

    confirmBill: postFun(url + `/ps/web/merchant/bill/confirm`), // 确认结算

    // 看板
    getDashboardList: getFun(url + `/ps/web/merchant/getDeliveryInfo`), // 看板数据
    getDashboardInfo: getFun(url + `/ps/web/merchant/dashboardInfo`),
    getDeliveryInfoByVersion: getFun(url + `/ps/web/merchant/getDeliveryInfoByVersion`), // 交付详情
    getRequirementPending: getFun(url + `/ps/web/merchant/requirement/pending`), // 查询待交付批次
    // 分片上传文件
    uploadChunkInit: postFun(url + `/ps/web/merchant/requirement/chunk/init`), // 初始化分片上传
    uploadChunk: postFun(url + `/ps/web/merchant/requirement/chunk/upload`), // 上传分片
    uploadChunkMerge: postFun(url + `/ps/web/merchant/requirement/chunk/merge`), // 合并分片
    uploadChunkCancel: postFun(url + `/ps/web/merchant/requirement/chunk/cancel`), // 取消分片上传
    getChunkUploaded: getFun(url + `/ps/web/merchant/requirement/chunk/uploaded`), // 查询已上传分片
    // 批次需求
    createRequirement: postFun(url + `/ps/web/merchant/requirement/create`), // 创建批次需求
    updateRequirement: putFun(url + `/ps/web/merchant/requirement/update`), // 更新批次需求
    getRequirementDraft: getFun(url + `/ps/web/merchant/requirement/draft`), // 查询批次需求草稿
    getRequirementById: id => getFun(url + `/ps/web/merchant/requirement/${id}`)(), // 查询批次需求
    deleteRequirement: id => deleteFun(url + `/ps/web/merchant/requirement/${id}`)(), // 删除批次需求
    submitRequirement: id => postFun(url + `/ps/web/merchant/requirement/${id}/submit`)(), // 提交批次需求

    // 通知管理
    getNotifyConfig: getFun(url + `/ps/web/merchant/notify/config`), // 获取通知配置
    updateNotifyConfig: postFun(url + `/ps/web/merchant/notify/config`), // 更新通知配置
    getNotifyUnread: getFun(url + `/ps/web/merchant/notify/unread`), // 获取未读通知
    markNotifyRead: postFun(url + `/ps/web/merchant/notify/markAsRead`), // 标记已读
    notifyStreamURL: url + `/ps/web/merchant/notify/stream`, // 获取通知流数据
    getUserBindQrCode: getFun(url + `/ps/web/merchant/user/wechat/bindQrCode`), // 生成绑定微信二维码
    getBindStatus: getFun(url + `/ps/web/merchant/user/wechat/bindStatus`), // 获取绑定状态
    rebindSmsMobile: postFun(url + `/ps/web/merchant/notify/rebindSmsMobile`), // 绑定手机号重新绑定
    unbindWechat: postFun(url + `/ps/web/merchant/user/wechat/unbind`), // 解绑微信
    // 支付
    payForOrder: postFun(url + `/ps/web/merchant/pay`), // 发起支付
    getOrderStatus: postFun(url + `/ps/web/merchant/paymentOrderStatus`), // 订单状态轮询
    rePayForOrder: postFun(url + `/ps/web/merchant/payForOrder`), // 重新发起支付
}